export default __webpack_public_path__ + "static/media/list_no_active.7a0f7c18.svg";